import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          We're under construction. Please check back for an update soon.
        </p>
      </header>
    </div>
  );
}

export default App;
